module.exports = __webpack_public_path__ + "static/media/window_accessibility.b0eb4e98.ico";